import React, {Component} from 'react';
import {NavLink, Link} from 'react-router-dom';
import {logo} from '../../../utils/Constants';
import {
    home,
    notification,
    scheduleType
} from '../../../utils/routes';
import { Dropdown, Navbar, Nav } from 'react-bootstrap';
import Logout from "../../../assets/static/svg/logout.svg";
import { ReactSVG } from 'react-svg';
import { loadState, removeStoreById } from "../../../LocalStore/localStorage";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import defaultImgSetup from "../../../redux/helper/defaultImgSetup";
import {accessLogSend} from "../../../redux/actions/instructor";

export class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            position: 0,
            userInfo: loadState('userInfo'),
        }
    }

    async componentDidMount() {

        await window.addEventListener("scroll", this.listenToScroll);

    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.listenToScroll);
    }

    listenToScroll = () => {
        const winScroll =
            document.body.scrollTop || document.documentElement.scrollTop;

        const height =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight;
        // const scrolled = winScroll / height;
        const scrolled = window.scrollY;

        this.setState({
            position: scrolled
        });
    };

    logout = async () => {
        await removeStoreById('userInfo');
        const {id, instructor_id, first_name, last_name, mobile_number} = this.state.userInfo;
        await this.props.dispatch(accessLogSend(`${id}|#|${instructor_id}|#|${first_name} ${last_name}|#|${mobile_number}`, 'Logout Done'));
        await window.location.reload()
    };


    render() {

        const { position, userInfo } = this.state;
        const { t } = this.props;
        return (
            <>
                {userInfo &&
                    <header className={position > 150 ? "header headerSticky" : "header"} id="header">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <Navbar expand="lg">
                                        <Link to={home} className="logo"><img src={logo} alt="img" /></Link>
                                        <Navbar.Toggle aria-controls="mainMenu">
                                            <span className="bar"></span>
                                            <span className="bar"></span>
                                            <span className="bar"></span>
                                        </Navbar.Toggle>
                                        <Navbar.Collapse id="mainMenu" className="mainMenu">
                                            <Nav className="ml-auto">
                                                <li className="nav-item">
                                                    <NavLink to={home} className="nav-link">{t('home')}</NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink to={scheduleType} className="nav-link">{t('Schedule')}</NavLink>
                                                </li>

                                                <li className="nav-item">
                                                    <Dropdown className="afterLogin">
                                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                            <div className="userIcon">
                                                                <div className="userImd">
                                                                    <img src={defaultImgSetup(userInfo.instructor_pic)}
                                                                        alt={defaultImgSetup(userInfo.instructor_pic)} />
                                                                </div>
                                                            </div>
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Link to={"#"} className="userProfile">
                                                                <div className="useImg">
                                                                    <img src={defaultImgSetup(userInfo.instructor_pic)}
                                                                        alt={defaultImgSetup(userInfo.instructor_pic)} />
                                                                </div>
                                                                <div className="userInfo">
                                                                    <h6 className="userName">{userInfo.first_name} {userInfo.last_name}</h6>
                                                                </div>
                                                            </Link>
                                                            <ul className="dropdownMenuList">
                                                                <li>
                                                                    <Link to={notification}>
                                                                        <span className="text">Notification</span>
                                                                        <span className="float-right">
                                                                            <span className="note">3</span>
                                                                        </span>
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link to={"/"} onClick={() => this.logout()}>
                                                                        <span className="text">Log out</span>
                                                                        <span className="float-right">
                                                                            <ReactSVG src={Logout} />
                                                                        </span>
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </li>
                                            </Nav>
                                        </Navbar.Collapse>
                                    </Navbar>
                                </div>
                            </div>
                        </div>
                    </header>
                }
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    subInfo: state.subInfo,
    userInfo: state.userInfo,
});

export default withTranslation()(connect(mapStateToProps)(Header));
